// extracted by mini-css-extract-plugin
module.exports = {"slidelayer":"style_slidelayer__3361w","active":"style_active__1sWlw","subhead":"style_subhead__kj9WR"};